import React from "react";
import { ShareApplicationPerson } from "@/types/ShareApplication";
import { InviteEmailButton } from "../InviteEmailButton";
import { CopyUrlComponent } from "../CopyUrlComponent";
import "./InviteCreatedAccountComponent.scss";

export interface InviteCreatedAccountComponentProps {
  person: ShareApplicationPerson;
  financialApplicationId?: string;
}

export const InviteCreatedAccountComponent: React.FC<InviteCreatedAccountComponentProps> = ({
  person,
  financialApplicationId,
}) => {
  return (
    <div className="invite-created-account-component">
      <h3>Share Application with {person.fullName}</h3>
      <p>
        An invite link has been created for this person. You can copy and share this link with them.
      </p>

      {person.validInviteLink ? (
        <>
          <CopyUrlComponent
            url={person.validInviteLink}
            label="Invite Link"
            description="Copy this link to share with the person"
          />

          <div className="invite-created-account-component__send-email-section">
            <InviteEmailButton
              person={person}
              financialApplicationId={financialApplicationId}
              buttonText="Send Invite Email"
              isReSend={false}
            />
          </div>
        </>
      ) : (
        <div className="invite-created-account-component__no-link">
          <p>No invite link available. Please try generating a new invite link.</p>
        </div>
      )}
    </div>
  );
};

export default InviteCreatedAccountComponent;
